export default __webpack_public_path__ + "static/media/Category-Social-Emotional-transparent.5d17a78f.png";